export type BlobOffsetType = {
  x: number;
  y: number;
};
export type ConfigType = number & boolean & BrandColorType;
export type UnitType = "cm" | "px" | "in" | "ft" | "m" | "mm";
export type ParticleFunctionType = {
  x: number;
  y: number;
  r: number;
  angle: number;
  vangle: number;
  zangle: number;
  originalZangle: number;

  centerX: number;
  centerY: number;
  offsetX: number;
  offsetY: number;

  maxRadius: number;
  minRadius: number;
  outerRadius: number;
  innerRadius: number;

  Move: (blobOffset: BlobOffsetType) => void;
};

export interface TallyLibraryConfigProps {
  width?: number;
  height?: number;
  margin?: number;
  particleMinRadius?: number;
  particleMaxRadius?: number;
  innerRadius?: number;
  offsetIndex?: boolean;
  particleOffset?: number;
  includeRadius?: boolean;
  offsetX?: number;
  offsetY?: number;
  blobStrength?: number;
  blobMultiplier?: number;
  blobSpeed?: number;
  includeMagnitation?: boolean;
  magnitationMultiplier?: number;
  vangleMultiplier?: number;
  dotColor?: BrandColorType;
  particleSpeedFactor?: number;
}

export type BrandColorType = "black" | "off-white" | "brown";
export enum BrandColorsEnum {
  "black" = "#000000",
  "off-white" = "#e3e3dc",
  "brown" = "#a97d58",
}

export interface ParticleController {
  play: () => void;
  pause: () => void;
  update: (config: TallyLibraryConfigProps) => void;
  pulseAnimation: () => void;
  start: () => void;
  stop: () => void;
  startPersistentCircleAnimation: () => void;
}

export interface TallyLibraryProps {
  canvas: HTMLCanvasElement;
  config?: TallyLibraryConfigProps;
}

export interface TallyLibraryFunction extends ParticleController {
  createParticle: (unit: UnitType, index: number) => ParticleFunctionType;
}

export interface TallyAnimationProps {
  width?: number;
  height?: number;
  particleAmount?: number;
  scale?: number;
  blobSpeed?: number;
  isResponsive?: boolean;
  responsiveFactor?: number;
  timelineRef?: React.MutableRefObject<gsap.core.Timeline | null>;
  startNowRef?: React.MutableRefObject<{
    triggerAnimationNow: (delay?: number) => void;
  } | null>;
}

export interface AnimationCustomConfigProps {
  duration?: number;
  ease?: string;
}
